import React from 'react';
import Toggle, { type ToggleProps } from './Toggle';

export type InlineToggleProps = Omit<ToggleProps, 'compact'> & {
  /** Inline toolbar / dialog layout (default true). */
  compact?: boolean;
};

/** Horizontally aligned toggle + label (8px gap, 44px touch target). */
export default function InlineToggle({ compact = true, className, ...props }: InlineToggleProps) {
  return (
    <Toggle
      compact={compact}
      className={['inline-toggle', className].filter(Boolean).join(' ')}
      {...props}
    />
  );
}

export { InlineToggle as ScoutlyInlineToggle };
